module.exports = __webpack_public_path__ + "img/paraguay.e6a6e396.svg";